import store from '../../store';
import SidebarCartItem from './SidebarCartItem.vue';

export default {
    components: { SidebarCartItem },

    data() {
        return {
            'products': []
        };
    },

    mounted() {
        this.featuredProducts();
    },

    methods: {
        featuredProducts() {
            $.ajax({
                type: 'GET',
                url: route('products.featured-product-cart'),
            }).then((response) => {
                return this.products = response;
            }).catch((xhr) => {
                
            }).always(() => {
                
            });
        }
    },

    computed: {
        cart() {
            return store.state.cart;
        },

        cartIsEmpty() {
            return store.cartIsEmpty();
        },

        cartIsNotEmpty() {
            return ! store.cartIsEmpty();
        }
    }
};
